
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/merch/[product_id]",
      function () {
        return require("private-next-pages/[id]/merch/[product_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/merch/[product_id]"])
      });
    }
  